<template>
  <div class="claimDetail">
    <div class="loading" id="loading" v-show="loading">
      <div class="circle"></div>
    </div>
    <div class="main claim">
      <div class="title">
        <p class="zhongan">
          WiFi安全险
          <img src="../images/zhongan.png" alt />
        </p>
        <!-- <p class="status" v-if="obj.claimState == 0">&nbsp;</p>
        <p class="status_success" v-if="obj.claimState == 2">&nbsp;</p>
        <p class="status_failed" v-if="obj.claimState == 1">&nbsp;</p> -->
        <div class="logo" v-if="obj.claimState == 0"></div>
        <div class="logo_success" v-if="obj.claimState == 2"></div>
        <div class="logo_failed" v-if="obj.claimState == 1"></div>
      </div>
    </div>
    <div id="claimPage" v-if="obj.claimState == 0">
      <!-- 受理中 begin-->
      <p class="limit">参保用户赔偿额度</p>
      <div class="block clearfix">
        <p class="bb">
          每一用户单日/单次索赔限额：
          <span>￥20,000元</span>
        </p>
        <p>
          每一用户累计最高可赔：
          <span>￥100,000元</span>
        </p>
      </div>
      <div class="block clearfix">
        <p class="bb">
          索赔流程:
          <router-link to="/new/claimFlow">查看详情</router-link>
        </p>
        <p class="bb">
          索赔资料:
          <router-link to="/new/docs">查看详情</router-link>
        </p>
        <p>
          服务热线:
          <a href="tel:4009999595">400-999-9595</a>
        </p>
      </div>
      <div class="block clearfix">
        <p class="bb">
          索赔资料收件人:
          <span class="small_font">WiFi万能钥匙商户安全理赔项目组</span>
        </p>
        <p class="bb">
          寄送地址:
          <span class="small_font">上海市浦东新区张衡路666弄1号楼7楼</span>
        </p>
        <p>
          快递联系电话:
          <span>400-035-8000</span>
        </p>
      </div>
      <!-- 受理中 end-->
    </div>
    <div id="claimSuccessPage" v-if="obj.claimState == 2">
      <!-- 受理成功 begin-->
      <div class="block clearfix">
        <p class="bb">
          索赔人:
          <span id="username">{{obj.userName}}</span>
        </p>
        <p class="bb">
          索赔金额:
          <span id="price">￥{{obj.claimMoney}}</span>
        </p>
        <p>
          银行卡号:
          <span id="bankCard">{{obj.blankCard}}</span>
        </p>
      </div>
      <div class="block clearfix">
        <p class="bb">
          索赔开始时间:
          <span id="startDate">{{obj.startDate}}</span>
        </p>
        <p>
          索赔结束时间:
          <span id="endDate">{{obj.endDate}}</span>
        </p>
      </div>
      <div class="block clearfix">
        <p id="reason">
          <span style="position: static;">备注:{{obj.dec}}</span>
        </p>
      </div>
      <!-- 受理成功 end-->
    </div>
    <div id="claimFailedPage" v-if="obj.claimState == 1">
      <!-- 受理失败 begin-->
      <div class="block clearfix">
        <p>
          索赔人:
          <span id="username">{{obj.userName}}</span>
        </p>
      </div>
      <div class="block clearfix">
        <p class="bb">
          索赔开始时间:
          <span id="startDate">{{obj.startDate}}</span>
        </p>
        <p>
          索赔结束时间:
          <span id="endDate">{{obj.endDate}}</span>
        </p>
      </div>
      <div class="block clearfix">
        <p id="reason">
          <span style="position: static;">备注:{{obj.dec}}</span>
        </p>
      </div>
      <!-- 受理失败 end-->
    </div>
  </div>
</template>

<script>
const AES = require("@/lib/Utils/AES").default;
export default {
  name: "newclaimDetail",
  data() {
    return {
      obj: {},
      loading: false,
    };
  },
  mounted() {
    this.obj = this.$route.query;
    console.log(`=====`, this.obj);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
  background-color: #f3f3f3;
  height: 100%;
  padding-bottom: 50px;
}
p {
  line-height: 45px;
  font-size: 14px;
}
.small_font {
  font-size: 12px;
}
.claimDetail {
  padding-top: 15px;
}
.main {
  display: block;
  position: relative;
  color: #666666;
  margin-top: 0;
  padding-bottom: 0;
}
.title {
  background-color: #ffffff;
  padding: 0 6%;
  height: 80px;
  border-top: 6px solid #6ab8f8;
}
.title .status {
  font-size: 14px;
  width: 50%;
  border-top: 1px solid #f2f2f2;
  font-weight: normal;
}
.title p {
  padding: 0;
}
.title .zhongan {
  font-size: 18px;
  color: #0285f0;
}
.title .zhongan img {
  width: 24%;
  position: absolute;
  right: 3%;
  top: 17px;
}
.title .logo {
  position: absolute;
  right: 6%;
  top: 21px;
  width: 60px;
  height: 60px;
  background-repeat: no-repeat;
  background-size: 100%;
}
.limit,
.block p {
  padding-left: 6%;
}

.block {
  background-color: #ffffff;
  position: relative;
  margin-bottom: 15px;
}
.block span,
.block a {
  position: absolute;
  right: 6%;
}
.block a {
  color: #0285f0;
}
.block p {
  color: #666666;
}

.bottom_btn {
  text-align: center;
  display: inline-block;
  width: 100%;
  font-size: 18px;
  color: #0285f0;
  background-color: #ffffff;
  line-height: 50px;
  text-decoration: none;
  border-top: #dbdbdb solid 1px;
  bottom: 0;
}
.foot {
  position: fixed;
}
.claimList {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  border-left: #dbdbdb solid 1px;
}
.claim .title .status {
  color: #f55e52;
}
.claim .title .logo {
  background-image: url(../images/claim.png);
}

.claim .title .status_success {
  color: #0285f0;
}
.claim .title .logo_success {
  background-image: url(../images/claim_success.png);
  width: 60px;
  height: 60px;
  position: absolute;
  right: 20px;
  top: 20px;
  background-repeat: repeat-x;
  background-position: center bottom;
  background-size: 100%;
}

.claim .title .status_failed {
  color: #666666;
}
.claim .title .logo_failed {
  background-image: url(../images/claim_failed.png);
  width: 60px;
  height: 60px;
  position: absolute;
  right: 20px;
  top: 20px;
  background-repeat: repeat-x;
  background-position: center bottom;
  background-size: 100%;
}
</style>



// WEBPACK FOOTER //
// claimDetail.vue?5580320a